import React from 'react';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { isMobile } from 'react-device-detect';

import {
  PopeyePromotionsList,
  PopeyePromotionItem,
  PromotionType,
  PromotionDates
} from './PromotionsList.style.js';
import {formatLocalizedDateRange} from "../../../library/helpers/dates";

const PromotionsList = ({ promotions, handlePromotionMobileClick, handlePromotionDesktopClick }) => {
  const { t } = useTranslation();
  if(!promotions.length) return null;
  return (
    <PopeyePromotionsList>
      {promotions.map(
        ({
          id,
          promotion_type,
          starts_discount_at,
          ends_discount_at,
          multiple_by,
          discount_percent,
          valid_between_start_date,
          valid_between_end_date
        }) => {
          let promotionTypeFormatted = '';
          let promotionColor = '';
          if (promotion_type === 'POINTS_MULTIPLIER') {
            promotionTypeFormatted = `X${multiple_by} ${t('POPEYE_DEALS_MULTIPLIER')}`;
            promotionColor = '#009ffd';
          } else if (promotion_type === 'DISCOUNT') {
            promotionTypeFormatted = `${t('POPEYE_DEALS_PERCENTAGE')} ${discount_percent}%`;
            promotionColor = '#fc7700';
          }

          return (
            <PopeyePromotionItem key={id}>
              <PromotionType
                promotionColor={ promotionColor }
                onClick={() =>
                  isMobile
                    ? handlePromotionMobileClick(valid_between_start_date, valid_between_end_date)
                    : handlePromotionDesktopClick(valid_between_start_date, valid_between_end_date)
                }
              >
                {promotionTypeFormatted}
              </PromotionType>
              <PromotionDates>{formatLocalizedDateRange(starts_discount_at, ends_discount_at)}</PromotionDates>
            </PopeyePromotionItem>
          );
        }
      )}
    </PopeyePromotionsList>
  );
};

export default PromotionsList;
